import React from 'react'

export type IDCDetailContextInfo = {
  caseID: string
  idcType: string
  transactionType: string
  processInstanceID: string
  OBSelectedCaseID: string
  setIsActiveTabIndex: (tabIndex: number) => void
  setOBSelectedCaseID: (caseID: string) => void
}

const defaultContextVal: IDCDetailContextInfo = {
  caseID: '',
  idcType: '',
  transactionType: '',
  processInstanceID: '',
  OBSelectedCaseID: '',
  setIsActiveTabIndex: (_) => {},
  setOBSelectedCaseID: (_) => {}
}

export const IDCDetailContext = React.createContext<IDCDetailContextInfo>(defaultContextVal)